import { FC } from "react";
import { CreateNewAppointmentRequest } from "@/components/appointmentRequest/createNewAppointmentRequest";
import RestrictedPage from "@/consumer/restrictedPage";

const AppointmentRequestCreate: FC = () => {
  return (
    <RestrictedPage permissionRequired="frontend_view_appointment_request">
      <CreateNewAppointmentRequest />
    </RestrictedPage>
  );
};

export default AppointmentRequestCreate;
